import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';

/**
 * Manages all things related to the Redux store required by UA modules.
 */
var store = /*#__PURE__*/function () {
  function store() {
    _classCallCheck(this, store);
  }
  _createClass(store, null, [{
    key: "createStore",
    value:
    /**
     * Configure the UA Redux store.
     * If a store is passed, this store will be used, otherwise UA will create its
     * own store using the {@link UAReducers}.
     *
     * Note: the expectation is that the Redux store that is passed is primed using
     * the {@link UAReducers} to ensure it can operate with the UA
     *
     * @param {any} inputStore [optional] a Redux store that includes the UAReducers
     *
     */
    function createStore(inputStore) {
      // a reference to the store that is passed from the wrapping application.
      this.internalStore = inputStore;
      if (!inputStore) {
        this.internalStore = configureStore({
          reducer: reducers,
          /**
           * An array of Redux middleware to install. No middleware supplied for now, defaults to
           * the set of middleware returned by `getDefaultMiddleware()`.
           *  See https://redux-toolkit.js.org/api/configureStore#middleware
           */
          middleware: function middleware(getDefaultMiddleware) {
            return getDefaultMiddleware({
              /**  serializableCheck: false, turns off warnings for usage of non-serializable data.
               * Most of the warnings come from passing localeData() in intlConfig and some data models.
               * See https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
               */
              serializableCheck: false
            });
          },
          preloadedState: {},
          devTools: process.env.NODE_ENV !== 'production',
          /**
           * The store enhancers to apply.
           * No enhancers for now.
           * See https://redux-toolkit.js.org/api/configureStore#enhancers.
           */
          enhancers: []
        });
      }
      return this.internalStore;
    }
  }]);
  return store;
}();
/**
 * A global reference to the store. Unlike universal-access-ui, there is no
 * connectors in the modules, therefore access to the store needs to happen
 * through the object itself. This allows modules to import and use the store
 * object.
 */
_defineProperty(store, "internalStore", null);
export { store as default };